import { ToggleButton, ToggleButtonItem } from '@apply/components';
import React from 'react';
import { DashboardOutstandingByPOCPivotMode } from '../../../../../../constants/DashboardOutstandingByPOCPivotMode';

export const DashboardOutstandingByPOCPivotModeToggleButton: React.FC<{
    pivotMode: DashboardOutstandingByPOCPivotMode;
    set_pivotMode: (mode: DashboardOutstandingByPOCPivotMode) => void;
}> = ({ pivotMode, set_pivotMode }) => {
    const pivotModes: ToggleButtonItem[] = [
        {
            id: DashboardOutstandingByPOCPivotMode.Committed,
            text: 'Commitments',
            hint: 'Display Committed Amounts',
        },
        {
            id: DashboardOutstandingByPOCPivotMode.Funded,
            text: 'Funded',
            hint: 'Display Funded Amounts',
        },
        {
            id: DashboardOutstandingByPOCPivotMode.Number,
            text: 'Number',
            hint: 'Display the Number of Outstanding Loans',
        },
    ];
    return (
        <ToggleButton
            id='outstandingByPOCPivotModeToggleButton'
            items={pivotModes}
            selectedItems={[pivotMode]}
            stylingMode='outlined'
            selectionMode='single'
            onItemClick={(e) => set_pivotMode(e?.itemData.id)}
            width='270px'
            height='24px'
            required={true}
        />
    );
};
